module.exports = __webpack_public_path__ + "img/common-jurisdiction.7caff425.png";